import Vue from "vue";
import { transformCompanyDataForBackend } from "@/transformer/onBoardingCompanyDataTransformer";
import axios from "./axios";

export const getServices = () => axios.get("api/services");

export const getFees = async () => {
    const response = await axios.get("api/fee/all");
    return response.data.data;
};

export const getSourceOfFundsAndReasonsToIncorporate = async() => Vue.prototype.$cache.rememberForever(`sourceOfFunds_${process.env.VUE_APP_CACHE_VERSION}`, async () => {
    const response = await axios.get('api/source-of-funds');
    return response.data.data;
});

export const getBusinessAddressPlanFee = async() => {
    const response = await axios.get('api/services/business-address-service/fee');
    return response.data.data;
};

export const getSecretaryServiceFee = async() => {
    const response = await axios.get('api/services/secretary-service/fee');
    return response.data.data;
};

export const getDirectorAndShareholderFee = async() => {
    const response = await axios.get('api/services/director-and-shareholder-service/fee');
    return response.data.data;
};

export const addToCart = async (userId, feeId, createdBy) => {
    const response = await axios.post("api/cart/store", {
        user_id: userId,
        fee_id: feeId,
        created_by: createdBy,
    });
    return response.data;
};

export const removeFromCart = async (userId, feeId) => {
    const response = await axios.delete(`api/cart/remove/${userId}/${feeId}`, {
        user_id: userId,
        fee_id: feeId
    });

    return response.data;
};

export const companyType = async () => {
    const response = await axios.get("/api/company-types");
    return response.data.data;
};

export const checkValidCompanyName = async name => {
    const response = await axios.post("/api/company/checkCompanyName", {
        name,
    });
    return response.data.data;
};

export const getBusinessActivities = async () => Vue.prototype.$cache.rememberForever(`businessActivity_${process.env.VUE_APP_CACHE_VERSION}`, async () => {
    const response = await axios.get("/api/business-activities");
    return response.data.data;
});

export const getCurrencies = async () => {
    const response = await axios.get("/api/currency/all");
    return response.data.data;
};

export const getDiscount = async discountName => {
    const response = await axios.get(`api/discounts/${discountName}`);
    return response.data.data;
};

export const getSignupDiscount = async () => {
    const response = await axios.get(`api/discounts/Signup discount`);
    return response.data.data;
};

export const postDataToServer= async payload => {
    const response = await axios.post('api/onBoarding/', transformCompanyDataForBackend({ payload }));

    return response.data.data;
};

export const getCartItems = async () => {
    const response = await axios.get('api/cart/items');

    return response.data.data;
};

export const storePayment = async() => {
    const response = await axios.post('api/payment');

    return response.data.data;
};

export const skipPaymentStep = async() => {
    const response = await axios.post('api/skip-payment');

    return response.data.data;
};

export const getBankDetails = async () => {
    const response = await axios.get('api/bank-details');

    return response.data.data;
};

export const getUserCompanies = async userId => {
    const response = await axios.get(`api/company/getUserCompanies/${userId}`);
    return response.data.data;
};

export const sendDocuments = async data => {
    const response = await axios.post("api/onboarding/send-documents", data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return response.data;
};
